import { arrayEach } from 'fela-utils';

var precedence = {
  ':link': 0,
  ':visited': 1,
  ':hover': 2,
  ':focus': 3,
  ':active': 4
};

var pseudoClasses = Object.keys(precedence);

function orderLVHA(style) {
  var pseudoList = [];

  for (var property in style) {
    if (precedence.hasOwnProperty(property)) {
      pseudoList[precedence[property]] = style[property];
      delete style[property];
    }
  }

  arrayEach(pseudoList, function (pseudoStyle, index) {
    if (pseudoStyle) {
      style[pseudoClasses[index]] = pseudoStyle;
    }
  });

  return style;
}

export default function LVHA() {
  return orderLVHA;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-plugin-lvha/es/index.js
// module id = 754
// module chunks = 0